import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin, Alert, Button } from "antd";

const VerifyNewEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // "loading", "success" oder "error"
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/verify-new-email/${token}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "Fehler bei der Verifizierung.");
        }
        setStatus("success");
        setMessage(data.message || "E-Mail erfolgreich verifiziert!");
      } catch (error) {
        console.error(
          "Fehler beim Verifizieren der neuen E-Mail:",
          error.message
        );
        setStatus("error");
        setMessage(error.message);
      }
    };

    verifyEmail();
  }, [token]);

  const handleRedirect = () => {
    // Hier kannst du z. B. zur Login-Seite oder zur Profilseite navigieren
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      {status === "loading" && <Spin size="large" />}
      {status === "success" && (
        <div className="text-center">
          <Alert message={message} type="success" showIcon />
          <Button
            type="primary"
            onClick={handleRedirect}
            className="mt-4 bg-orange-500"
          >
            Weiter
          </Button>
        </div>
      )}
      {status === "error" && (
        <div className="text-center">
          <Alert
            message="Verifizierung fehlgeschlagen"
            description={message}
            type="error"
            showIcon
          />
          <Button
            type="primary"
            onClick={handleRedirect}
            className="mt-4 bg-orange-500"
          >
            Zurück zur Anmeldung
          </Button>
        </div>
      )}
    </div>
  );
};

export default VerifyNewEmail;
